import {
  applyDialogPopupWindowGeometry,
  buildCenteredDialogPopupWindow,
  focusDialogPopupWindow,
} from "../../../services/dialogPopupWindow";

let activePopupWindow: Window | null = null;

export const SLIDE_LIBRARY_COMMAND_MESSAGE_KIND = "finster.slideLibrary.command";
export const SLIDE_LIBRARY_RESPONSE_MESSAGE_KIND = "finster.slideLibrary.response";

export interface SlideLibraryAddToPresentationItem {
  id: string;
  title?: string;
  base64Slides?: string;
  pptxSources?: string[];
}

export interface SlideLibraryAddToPresentationCommand {
  type: "addToPresentation";
  requestId: string;
  items: SlideLibraryAddToPresentationItem[];
}

export interface SlideLibraryCommandEnvelope {
  kind: typeof SLIDE_LIBRARY_COMMAND_MESSAGE_KIND;
  payload: SlideLibraryAddToPresentationCommand;
}

export interface SlideLibraryAddToPresentationResponse {
  type: "addToPresentationResult";
  requestId: string;
  insertedCount: number;
  failedCount: number;
  error?: string;
}

export interface SlideLibraryResponseEnvelope {
  kind: typeof SLIDE_LIBRARY_RESPONSE_MESSAGE_KIND;
  payload: SlideLibraryAddToPresentationResponse;
}

function getDialogUrl(companyId?: string): string {
  const url = new URL(`${window.location.origin}/dialogs/slide-library.html`);
  const trimmedCompanyId = companyId?.trim();
  if (trimmedCompanyId) {
    url.searchParams.set("companyId", trimmedCompanyId);
  }
  return url.toString();
}

export function openSlideLibraryDialog(options?: { companyId?: string }): void {
  const popupWindow = buildCenteredDialogPopupWindow();
  if (activePopupWindow) {
    try {
      if (!activePopupWindow.closed) {
        applyDialogPopupWindowGeometry(activePopupWindow, popupWindow);
        focusDialogPopupWindow(activePopupWindow);
        return;
      }
    } catch {
      activePopupWindow = null;
    }
  }

  const popup = window.open(
    getDialogUrl(options?.companyId),
    "finster_slide_library",
    popupWindow.features
  );

  if (!popup) {
    throw new Error("Popup blocked. Please allow popups for this site and try again.");
  }
  applyDialogPopupWindowGeometry(popup, popupWindow);
  focusDialogPopupWindow(popup);
  activePopupWindow = popup;
}
